module.exports = __webpack_public_path__ + "static/img/xwq_03.e4774b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xwq_03.png
// module id = KMnb
// module chunks = 0